import { sliceSelectionTrigger } from '../components/Legacy/events/events'

function flyTripSelection(slice, sliceId, selected, tripType) {
  const sliceKey = slice.sliceKey

  const sliceFilterParam = {
    sliceKey,
    sliceId
  }

  const gaLabel = `${tripType}${sliceId}`
  const selectionInfo = {
    gaLabel,
    sliceFilterParam,
    isSelect: !selected
  }

  sliceSelectionTrigger.dispatch(selectionInfo)
}

export { flyTripSelection }
